import SubcontractorTimesheetEdit from "./SubcontractorTimesheetEdit";
import SubcontractorTimesheetList from "./SubcontractorTimesheetList";
import ListAltIcon from "@material-ui/icons/ListAlt";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  icon: ListAltIcon,
  name: "subcontractorTimesheets",
  edit: SubcontractorTimesheetEdit,
  list: SubcontractorTimesheetList,
};
